import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-vendordashboard',
  templateUrl: './vendordashboard.component.html',
  styleUrls: ['./vendordashboard.component.css']
})
export class VendordashboardComponent implements OnInit {

  data: any;
  filledOrder: any;
  pendingOrder: any;
  userData : any;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private orderServices: OrderService) { }

  ngOnInit() {
    this.getOrderList();
    this.getMyFilledOrder();
    this.getMyPendingOrder();
    this.getCurrentUserData();
  }

  getCurrentUserData()
  {
    this.userService.getUserProfile().subscribe(
      (data : any) => {
        this.userData = data;
        console.log(this.userData);
      }
    )
  }

  getOrderList() {
    this.orderServices.getMyOrderList().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  getMyFilledOrder() {
    this.orderServices.getMyFilledOrder().subscribe(
      (data: any) => {
        this.filledOrder = data;
        console.log(this.data);
      }
    )
  }

  getMyPendingOrder() {
    this.orderServices.getMyPendingOrder().subscribe(
      (data: any) => {
        this.pendingOrder = data;
        console.log(this.data);
      }
    )
  }

  ViewOrder(orderno : string)
  {
    if (orderno != null) {
      this.router.navigate(['/manageorder',orderno]);
    }
  }

}
